import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c23wth5k4: FaireProductEntity = {
  token: "p_5c23wth5k4",
  type: "product",
  name: "Natural Bamboo Knotted Gown",
  brandToken: "b_jksxubn7g5",
  brandName: "Marlowe & Co",
  imageUrl:
    "https://cdn.faire.com/fastly/7b55cc70d5fa5fe772d4be6416a22dd4697d372ab110e87f46e73a0a94585e55.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fee3ff80332a7ce279e9f807292f130eac1d9155651ab5021fa57e7b45eac3b.jpeg",
    "https://cdn.faire.com/fastly/da37d85ea5700aede2f6ab4d3bb74ab01ff91dd8d0a285d53c9788f94b6115e5.jpeg",
    "https://cdn.faire.com/fastly/b80c0d166123d87979d0cbcc9b142945960f780b118b07670d821e6c550682b5.jpeg",
    "https://cdn.faire.com/fastly/5347109f0454a29ea93570b7cc4f9ca368d7789a51dde99e47c4e22b9d2014a5.jpeg",
    "https://cdn.faire.com/fastly/45f910b4c7d9db7a9250f8b1b696f64bf78c3d4ec50d723678b3d98771e7a5a6.jpeg",
    "https://cdn.faire.com/fastly/5140e17e94f2bc7dfdcea216a48659fdba0ccbac7b60637c3e0576d188166e6d.jpeg",
    "https://cdn.faire.com/fastly/056028d0252174d0792d89bc8d483f535eec83bf274c8a663dd6f6e3534cfd4b.jpeg",
    "https://cdn.faire.com/fastly/749a3a14ea70a9157da8935877c806ebc9e485069aacc6ff315581825f67dc11.jpeg",
    "https://cdn.faire.com/fastly/9bfe919fd36b8ecbdc7dbcd6a396988b869069725b5950163ebae09792bd2cca.jpeg",
    "https://cdn.faire.com/fastly/bf377ea8fec0053257e1ce043edce23ff63df00e5faf2bc6d7cee6a619232a60.jpeg",
    "https://cdn.faire.com/fastly/ec99adb902098242ddf3d3f485b6877fd0d899660e398a50351551cc3cbc2e7e.jpeg",
    "https://cdn.faire.com/fastly/35b57f257d608c24563387c515d8e7baff23046bc5ca36f6f2c6a20dd58e7039.jpeg",
    "https://cdn.faire.com/fastly/cdfb94c399f2be9785a1e42ff44628cd996af81d7f9460d50793ebb899e02d3e.jpeg",
  ],
  priceDollars: 12,
  description:
    "\nMarlowe & Co's natural knotted gown is made from a soft buttery blend of 95% viscose from bamboo and 5% spandex fabric.\n\nViscose from Bamboo is one of the softest and most eco-friendly fabric choices for your little one, and will keep your baby comfortable in all seasons. Our gowns are made with high quality stitching, and will not lose their softness over time. Designed to be soft and delicate on your baby’s skin, our gowns will provide the perfect amount of stretch and comfort for you little one. The length of the knot is adjustable to allow your baby to grow with the gown. \n\nFeatures:\n~ Size: 0-3 Months\n~ Material: 95% Viscose from bamboo/5% spandex\n~ Matching swaddle blanket available\n~ Machine wash with like colors, air dry or tumble dry low\n\nUPC 850032765008\n\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:18.359Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
